import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import type {
  ArtistCategoryFilter,
  ArtistOrderSort,
  MediumFilter,
  MultiOptionFilter,
  SingleOptionFilter,
} from '../types/Filters';
import { useMultiOptionQueryParam } from './useMultiOptionQueryParam';
import { usePathname } from './usePathname';
import { useQueryParam } from './useQueryParam';

export type ArtistFiltersController = {
  categories: MultiOptionFilter<ArtistCategoryFilter>;
  mediums: MultiOptionFilter<MediumFilter>;
  order: SingleOptionFilter<ArtistOrderSort>;
  searchTerm: SingleOptionFilter<string>;
  isEstate: SingleOptionFilter<string>;

  isInteractedWith: boolean;
  setIsInteractedWith: (value: boolean) => void;

  clearAll: () => void;
};

export const useArtistFilters = (): ArtistFiltersController => {
  const router = useRouter();
  const pathname = usePathname();

  const [isInteractedWith, setIsInteractedWith] = useState(false);

  const categories = useMultiOptionQueryParam<ArtistCategoryFilter>({
    key: 'category',
  });

  const mediums = useMultiOptionQueryParam<MediumFilter>({
    key: 'medium',
  });

  const order = useQueryParam<ArtistOrderSort>({
    key: 'order',
    fallbackValue: 'Relevance',
  });

  const searchTerm = useQueryParam<string>({
    key: 'q',
    fallbackValue: '',
  });

  const isEstate = useQueryParam<string>({
    key: 'estates',
    fallbackValue: '',
  });

  const clearAll = useCallback(() => {
    router.push(pathname, undefined, { shallow: true });
  }, []);

  return {
    categories,
    mediums,
    order,
    searchTerm,
    isEstate,
    isInteractedWith,
    setIsInteractedWith,
    clearAll,
  };
};
